// extracted by mini-css-extract-plugin
export default {"projectWrapper":"project_projectWrapper__WASdl","projectBackground":"project_projectBackground__x57Wb","projectTop":"project_projectTop__pLbfv"};